import React, { useEffect } from "react";
import usePreguntatresGame from "./usePreguntatresGame";
import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import "./style.scss";

const PreguntaTres: React.FC<RouteProps> = () => {
  const [
    currentQuestionIndex,
    questionsInfo,
    totalQuestions,
    correctAnswersCount,
    name,
    setName,
    onAnswerClick,
    generateQuestions,
    restartGame
  ] = usePreguntatresGame();

  //Esto es para que no se cambie el color en todas las paginas
  useEffect(() => {
    document.body.style.backgroundColor = "#2d3436";
  }, []);

  return (
    <Container className='example-preguntatres-content'>
      <div className='progress m-5'>
        <div
          className='progress-bar bg-warning'
          role='progressbar'
          style={{
            width: (currentQuestionIndex * 100) / (totalQuestions - 1) + "%"
          }}
          aria-valuenow={25}
          aria-valuemin={0}
          aria-valuemax={100}></div>
      </div>
      {currentQuestionIndex === -1 && (
        <Container>
          <Container
            className='p-3 mb-2 text-dark rounded'
            style={{ backgroundColor: "#0984e3" }}>
            <div className='h1 text-light'>Bienvenido al PreguntaTres</div>
            <div className='h4 text-light'>
              Responde una serie de preguntas (en inglés) y ganate algo...
              todavía no sé
            </div>
            <br />
            <div className='h6 text-light'>Ingresa tu nombre, si querés</div>
            <input
              type='text'
              name='nombre'
              id='input-name'
              onChange={e => setName(e.target.value)}
            />
          </Container>
          <input
            type='button'
            value='Comenzar'
            onClick={() => generateQuestions()}
          />
        </Container>
      )}
      {currentQuestionIndex === totalQuestions && (
        <Container>
          <Container
            className='p-3 mb-2 text-dark rounded'
            style={{ backgroundColor: "#0984e3" }}>
            <div className='h1 text-light'>
              Felicidades {name !== "" ? name : " persona sin nombre"},
            </div>
            <div className='h4 text-light'>
              terminaste todas las preguntas con un resultado de{" "}
              {correctAnswersCount} respuestas correctas!
            </div>
            {correctAnswersCount === totalQuestions && (
              <div className='h6 text-light'>Un puntaje perfecto!</div>
            )}
          </Container>
          <input
            type='button'
            value='Jugar de nuevo'
            onClick={() => restartGame()}
          />
        </Container>
      )}
      {currentQuestionIndex >= 0 && currentQuestionIndex < totalQuestions && (
        <Container>
          <div className='example-preguntatres-question'>
            {questionsInfo[currentQuestionIndex].question}
          </div>
          {Object.values(questionsInfo[currentQuestionIndex].answers).map(
            (q, index) => {
              return (
                <div
                  id={q[1] ? "correctAnswer" : "b" + index}
                  onClick={event =>
                    onAnswerClick(q[1] as boolean, event.target as Element)
                  }
                  className='example-preguntatres-answer'
                  style={{ animationDelay: "0." + index + "s" }}>
                  {q[0]}
                </div>
              );
            }
          )}
        </Container>
      )}
    </Container>
  );
};

export default new Content({
  Component: PreguntaTres,
  title: "PreguntaTres",
  route: "preguntatres"
});
